import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconCheckboxSmallChecked = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		x: 2.7,
		y: 2.7,
		width: 12.6,
		height: 12.6,
		rx: 3.3,
		fill: "#0A8FF5",
		stroke: "#0A8FF5",
		strokeWidth: 1.4
	}), /* @__PURE__ */ _jsx("path", {
		d: "M10.9179 6.61133C11.1325 6.29003 11.5671 6.20363 11.8886 6.41798C12.2099 6.63253 12.2963 7.06716 12.082 7.38868L9.08199 11.8887C8.95808 12.0742 8.75316 12.1896 8.53023 12.1992C8.30714 12.2089 8.09257 12.1119 7.95308 11.9375L5.95308 9.43751C5.71157 9.13562 5.76057 8.69464 6.06245 8.45313C6.36434 8.21163 6.80532 8.26062 7.04683 8.56251L8.4482 10.3145L10.9179 6.61133Z",
		fill: "white"
	})]
});
export default SvgIconCheckboxSmallChecked;
